export default "__VITE_PUBLIC_ASSET__5fc77d89__"